import React from "react";
import {getSyncEngineVersion} from "../common/helpers/syncEngine";
import {Economic as EconomicV1} from "../features/private/EconomicV1";
import {Economic as EconomicV2} from "../features/private/EconomicV2";
import {SettingsLayout} from "../layouts/dashboard/SettingsLayout";
import {LegacySettingsRedirect} from "./LegacySettingsRedirect";
import {RouteDefine} from "./RouteDefine";

/** V2 only — wrapped in unified settings shell */
export function SettingsEconomicRoute() {
    if (getSyncEngineVersion() !== "v2") {
        return <LegacySettingsRedirect to={RouteDefine.economic}/>;
    }

    return (
        <SettingsLayout>
            <EconomicV2/>
        </SettingsLayout>
    );
}

/** V1 legacy URL — frozen shell via UseSecondLayout inside EconomicV1 */
export function LegacyEconomicRoute() {
    if (getSyncEngineVersion() === "v2") {
        return <LegacySettingsRedirect to={RouteDefine.settingsEconomic}/>;
    }

    return <EconomicV1/>;
}
